import axios from 'axios';

const isValidToken = (accessToken) => {
  if (!accessToken) return false;
  return true;
};

const getSession = () => {
  return localStorage.getItem('token');
};

const setSession = (token) => {
  if (token) {
    localStorage.setItem('token', token);
    axios.defaults.headers.common.Authorization = token;
    axios.defaults.headers.common.lt = token;
    axios.defaults.headers.common.l = 'en';
    // This function below will handle when token is expired
    // const { exp } = jwtDecode(token);
    // handleTokenExpired(exp);
  } else {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common.Authorization;
    delete axios.defaults.headers.common.t;
  }
};

export { isValidToken, setSession, getSession };
